<template>
  <div>
    <div class="list-area">
      <div v-if="noData" class="no-contents">조회 결과가 없습니다</div>
      <vertical-list-slider
        :listItems="listItems"
        :topBanner="topBanner"
        :componentStyle="componentStyle"
        :isActiveVue="isActiveVue"
        :key="componentKey"
        @refresh="getData(true)"
      ></vertical-list-slider>
    </div>
  </div>
</template>

<script>
import VerticalListSlider from "../components/slider/VerticalListSlider.vue";

export default {
  components: {
    VerticalListSlider,
  },
  data() {
    return {
      isActiveVue: true,
      noData: false,
      componentKey: 0,
      loadingTimer: false,
    };
  },
  computed: {
    componentStyle() {
      const innerWidth = Number(window.innerWidth);
      let style = {
        left: "176px",
        width: "436px",
        height: "402px",
      };

      if (innerWidth < 1920) {
        style = {
          left: "120px",
          width: "306px",
          height: "322px",
        };
      }

      return style;
    },
    topBanner() {
      return this.$store.getters.topBannerInfo;
    },
    listItems() {
      return this.$store.getters.homeData;
    },
    fousedView() {
      return this.$store.getters.focusedView;
    },
  },
  beforeRouteEnter: (to, from, next) => {
    // VOD, LIVE 플레이어 종료 시 컨텐츠 업데이트 여부 확인
    next((vm) => {
      if (from.path.indexOf("player") > -1) {
        vm.getData(true);
      }
    });
  },
  watch: {
    fousedView(val) {
      if (this.isActiveVue == true && val == "default" && this.noData == true) {
        this.$store.commit("SET_FOCUSED_VIEW", "gnb");
      }
    },
  },
  methods: {
    async getData(showNotice = false) {
      this.$progress.$emit("on:progress");

      if (!this.loadingTimer) {
        this.loadingTimer = true;
        this.$store
          .dispatch("FETCH_USER_SUBSCRIPTION")
          .then(() => {})
          .finally(() => {
            this.loadingTimer = false;
          });
      }

      await this.$store.dispatch("FETCH_HOME_HASH").then((isUpdated) => {
        if (isUpdated) {
          // homeHash 값이 다른 경우 컨텐츠 업데이트
          this.$store.dispatch("FETCH_TOP_BANNER_INFO");
          this.$store.dispatch("FETCH_HOME_DATA").then((response) => {
            if (!response || !response.data || response.data.length == 0) {
              this.noData = true;
              this.$store.commit("SET_FOCUSED_VIEW", "gnb");
            } else {
              // 플레이어에서 홈화면으로 돌아온 경우 알림 노출
              if (showNotice) {
                this.componentKey += 1;
                this.$notification.$emit("on:visible");
              }
            }
            this.$progress.$emit("off:progress");
          });
        } else this.$progress.$emit("off:progress");
      });
    },
  },
  created() {
    this.$store.commit("SET_FOCUSED_VIEW", "default");
    this.getData();
  },
  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.isActiveVue = false;
  },
};
</script>

<style scoped>
.list-area {
  position: relative;
}
.banner-img {
  left: 0;
  top: 0;
  width: 1792px;
  height: 448px;
}
.no-contents {
  font-size: 32px;
  left: 650px;
  top: 460px;
  width: 400px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  background-color: rgba(30, 30, 30, 0.95);
}
@media all and (min-width: 0px) and (max-width: 1280px) {
  .list-area {
    position: relative;
    width: 1280px;
    height: 720px;
  }
  .banner-img {
    left: 0;
    top: 0;
    width: 1792px;
    height: 448px;
  }
  .no-contents {
    font-size: 32px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 400px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background-color: rgba(30, 30, 30, 0.95);
  }
}
</style>
